import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { newsItems } from "@/mocks/news";

interface NewsDetailProps {
  item: NewsItem;
}

export default function NewsDetail({ item }: NewsDetailProps) {
  const others = newsItems.filter((n) => n.id !== item.id).slice(0, 5);

  return (
    <div className="w-full px-4 md:px-6 pt-6">
      <div className="lg:flex lg:gap-8">
        <article className="min-w-0 flex-1">
          <div className="rounded-lg bg-background-100 p-5 ring-1 ring-background-200 md:p-8">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
              <i className="ri-price-tag-3-line"></i>
              {item.tag}
            </span>
            <h1 className="mt-4 text-2xl font-bold text-foreground-950 font-heading md:text-4xl">
              {item.title}
            </h1>
            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 border-b border-background-200 pb-5 text-sm text-foreground-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {item.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-newspaper-line"></i>
                {item.source}
              </span>
            </div>

            <div className="mt-6 w-full aspect-[16/9] overflow-hidden rounded-lg">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} 影视资讯`}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <p className="mt-6 border-l-4 border-accent-500 bg-accent-50 px-4 py-3 text-sm leading-relaxed text-foreground-800 md:text-base">
              {item.summary}
            </p>

            <div className="mt-6 space-y-4">
              {item.content.map((paragraph, index) => (
                <p
                  key={index}
                  className="text-sm leading-loose text-foreground-700 md:text-base"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-8 rounded-md bg-secondary-50 p-4 text-xs leading-relaxed text-secondary-900">
              本文由唐心影视整理发布，内容仅用于演示展示，相关数据与观点不代表任何官方立场。欢迎继续浏览唐心更多影视资讯与作品推荐。
            </div>
          </div>
        </article>

        <aside className="mt-6 w-full lg:mt-0 lg:w-80 lg:shrink-0">
          <section className="rounded-lg bg-background-100 p-5 ring-1 ring-background-200">
            <h2 className="text-sm font-bold text-foreground-950 font-heading">
              所属分类
            </h2>
            <div className="mt-3 flex flex-wrap gap-2">
              <Link
                to="/category/资讯"
                className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700 hover:bg-primary-200 transition-colors cursor-pointer"
              >
                影视资讯
              </Link>
              <Link
                to={`/category/资讯`}
                className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 hover:bg-secondary-200 transition-colors cursor-pointer"
              >
                {item.tag}
              </Link>
            </div>
          </section>

          <section className="mt-6 rounded-lg bg-background-100 p-5 ring-1 ring-background-200">
            <h2 className="text-sm font-bold text-foreground-950 font-heading">
              最新资讯
            </h2>
            <div className="mt-4 flex flex-col gap-4">
              {others.map((news) => (
                <Link
                  key={news.id}
                  to={`/detail/${news.id}`}
                  className="group flex gap-3 cursor-pointer"
                >
                  <div className="w-20 h-14 shrink-0 overflow-hidden rounded-md">
                    <img
                      src={news.cover}
                      alt={news.title}
                      title={`${news.title} 资讯`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-xs font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {news.title}
                    </h3>
                    <span className="mt-1 block text-xs text-foreground-400">
                      {news.date}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </aside>
      </div>
    </div>
  );
}